import { render, staticRenderFns } from "./LmBlueprintTypesPrivileges.vue?vue&type=template&id=740528b6&"
import script from "./LmBlueprintTypesPrivileges.vue?vue&type=script&lang=js&"
export * from "./LmBlueprintTypesPrivileges.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports